export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/workspace/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/admin',
    /* internal name: '/admin' */
    /* no component */
    children: [
      {
        path: 'announcements',
        name: '/admin/announcements',
        component: () => import('/workspace/src/pages/admin/announcements.vue'),
        /* no children */
      },
      {
        path: 'dashboard',
        name: '/admin/dashboard',
        component: () => import('/workspace/src/pages/admin/dashboard.vue'),
        /* no children */
      },
      {
        path: 'qna',
        name: '/admin/qna',
        component: () => import('/workspace/src/pages/admin/qna.vue'),
        /* no children */
      },
      {
        path: 'users',
        name: '/admin/users',
        component: () => import('/workspace/src/pages/admin/users.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/announcements',
    name: '/announcements',
    component: () => import('/workspace/src/pages/announcements.vue'),
    /* no children */
  },
  {
    path: '/demo',
    /* internal name: '/demo' */
    /* no component */
    children: [
      {
        path: '',
        name: '/demo/',
        component: () => import('/workspace/src/pages/demo/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/login',
    /* internal name: '/login' */
    /* no component */
    children: [
      {
        path: '',
        name: '/login/',
        component: () => import('/workspace/src/pages/login/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/public',
    /* internal name: '/public' */
    /* no component */
    children: [
      {
        path: '',
        name: '/public/',
        component: () => import('/workspace/src/pages/public/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/quality',
    /* internal name: '/quality' */
    /* no component */
    children: [
      {
        path: '',
        name: '/quality/',
        component: () => import('/workspace/src/pages/quality/index.vue'),
        /* no children */
      },
      {
        path: 'manage',
        /* internal name: '/quality/manage' */
        /* no component */
        children: [
          {
            path: 'checklists',
            /* internal name: '/quality/manage/checklists' */
            /* no component */
            children: [
              {
                path: '',
                name: '/quality/manage/checklists/',
                component: () => import('/workspace/src/pages/quality/manage/checklists/index.vue'),
                /* no children */
              },
              {
                path: ':setId',
                name: '/quality/manage/checklists/[setId]',
                component: () => import('/workspace/src/pages/quality/manage/checklists/[setId].vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'members',
            name: '/quality/manage/members',
            component: () => import('/workspace/src/pages/quality/manage/members.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'manual',
        name: '/quality/manual',
        component: () => import('/workspace/src/pages/quality/manual.vue'),
        /* no children */
      },
      {
        path: 'task',
        /* internal name: '/quality/task' */
        /* no component */
        children: [
          {
            path: ':taskId',
            /* internal name: '/quality/task/[taskId]' */
            /* no component */
            children: [
              {
                path: '',
                name: '/quality/task/[taskId]/',
                component: () => import('/workspace/src/pages/quality/task/[taskId]/index.vue'),
                /* no children */
              },
              {
                path: 'inspection',
                /* internal name: '/quality/task/[taskId]/inspection' */
                /* no component */
                children: [
                  {
                    path: ':inspectionId',
                    name: '/quality/task/[taskId]/inspection/[inspectionId]',
                    component: () => import('/workspace/src/pages/quality/task/[taskId]/inspection/[inspectionId].vue'),
                    /* no children */
                  }
                ],
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/task',
    /* internal name: '/task' */
    /* no component */
    children: [
      {
        path: ':taskId',
        name: '/task/[taskId]',
        component: () => import('/workspace/src/pages/task/[taskId].vue'),
        children: [
          {
            path: '',
            name: '/task/[taskId]/',
            component: () => import('/workspace/src/pages/task/[taskId]/index.vue'),
            /* no children */
          },
          {
            path: 'facility',
            /* internal name: '/task/[taskId]/facility' */
            /* no component */
            children: [
              {
                path: ':facilityId',
                name: '/task/[taskId]/facility/[facilityId]',
                component: () => import('/workspace/src/pages/task/[taskId]/facility/[facilityId].vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

